import { Capacitor } from '@capacitor/core';

/**
 * Router-aware hard redirect.
 *
 * The app uses BrowserRouter on the web build and HashRouter inside the
 * Capacitor native WebView (see src/App.js). A raw `window.location` redirect
 * therefore needs different forms per platform:
 *   - web (BrowserRouter):   /login
 *   - native (HashRouter):   #/login
 *
 * Use this helper anywhere a full-page redirect is needed from non-component
 * code (e.g. api helpers) or simple buttons, so routing resolves correctly on
 * both platforms. Prefer react-router's useNavigate() inside components when
 * available.
 *
 * @param {string} path absolute app path, e.g. "/" or "/login"
 */
export const hardRedirect = (path) => {
  const p = path.startsWith('/') ? path : `/${path}`;
  if (Capacitor.isNativePlatform()) {
    window.location.hash = `#${p}`;
  } else {
    window.location.href = p;
  }
};
